import { render, staticRenderFns } from "./referenceRecipeNew.vue?vue&type=template&id=46112dc0&"
import script from "./referenceRecipeNew.vue?vue&type=script&lang=js&"
export * from "./referenceRecipeNew.vue?vue&type=script&lang=js&"
import style0 from "./referenceRecipeNew.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports